// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3ysvZ","rootSmall":"AddTileButton_rootSmall__2tOQD"};